import { configureStore } from "@reduxjs/toolkit";
import cartSlice from "../Features/Cart/cartSlice";
import wishListSlice from "../Features/Wishlist/wishListSlice";
import productSlice from "../Features/Product/productSlice";
import productReducer from '../Features/filter/fetch_products';
import orderReducer from "../Features/Order/userorderhistory";
import reviewsReducer from "../Features/Reviews/reviewsSlice"; 
import favoritesReducer from "../Features/Favorite/favoritesSlice";
import favoriteScreenReducer from "../Features/FavoriteScreen/favoriteScreen";
import homeReducer from "../Features/Home/home_slice";
const store = configureStore({
  reducer: {
    cart: cartSlice,
    wishlist: wishListSlice,
    product: productSlice,
    products: productReducer,
    orders: orderReducer,
    reviews: reviewsReducer,
    favorites: favoritesReducer,
    favoriteScreen: favoriteScreenReducer,
    home: homeReducer,
  },
});

export default store;
